import "./App.css";
import CelebrityList from "./Components/CelebrityList";

function App() {
  return <CelebrityList />;
}

export default App;
